import { render, staticRenderFns } from "./MyPagePoint.vue?vue&type=template&id=c72de41c&scoped=true&"
import script from "./MyPagePoint.vue?vue&type=script&lang=js&"
export * from "./MyPagePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72de41c",
  null
  
)

export default component.exports